import { render } from "./VideoHistoryComponent.vue?vue&type=template&id=25c60562&scoped=true"
import script from "./VideoHistoryComponent.vue?vue&type=script&lang=js"
export * from "./VideoHistoryComponent.vue?vue&type=script&lang=js"

import "./VideoHistoryComponent.vue?vue&type=style&index=0&id=25c60562&lang=scss&scoped=true"

import exportComponent from "/Users/zhanglinjun/Downloads/genescloud_wechat-master-d167e5133fddc18883d58aba5b516d53ee974944/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25c60562"]])

export default __exports__